import { useNavigator } from '@repo/toolkit/use-navigator'
import { ChevronLeftIcon } from '@repo/ui/icons'
import { useParams } from 'react-router-dom'

import UserNavBar from '../../components/elements/nav-bar'
import MissionDetails from '../../components/pages/mission/mission-details'
import { Paths } from '../../lib/constants/path'

const MissionViewPage = () => {
  const { id: paramId } = useParams<{ id: string }>()
  const { back } = useNavigator()

  if (!paramId) return null

  return (
    <div>
      <UserNavBar
        title={`Mission - Libellé`}
        icon={ChevronLeftIcon}
        onIconClick={() => back(Paths.MISSION_LIST_PAGE)}
      />
      <div className={'h-4'} />
      <MissionDetails showStaffTable missionId={+paramId} />
    </div>
  )
}
export default MissionViewPage
